import _, {escapeRegExp} from 'lodash';
import React from 'react';
import ParticipantsList from '../ParticipantsList';

function AlphabeticalParticipantsList(props) {
    const {className = '', eventId, participants = [], savePosition, busy, routePrefix} = props,
        list = _(participants)
            .map(participant => {
                return (participant.sortstring || ' ')[0].toUpperCase();
            })
            .uniq()
            .sortBy(letter => {
                return letter;
            })
            .map(letter => {
                const re = new RegExp('^' + escapeRegExp(letter), 'i');

                return {
                    title: letter,
                    items: _(participants)
                        .filter(participant => {
                            return participant.sortstring.match(re);
                        })
                        .sortBy('sortstring')
                        .value(),
                };
            })
            .value();

    return <ParticipantsList className={className} eventId={eventId} list={list} savePosition={savePosition} busy={busy} routePrefix={routePrefix} />;
}

export default AlphabeticalParticipantsList;
